import Lottie from 'lottie-react';
import SuccessAnimation from "assets/images/SuccessAnimation.json";
import { Img } from 'components';

const ProcessComplete = () => {
    return (
        <div className='font-manrope flex flex-col justify-center items-center text-center w-screen h-[90vh] gap-4'>
            <Lottie animationData={SuccessAnimation} loop={false} />
            <p className="text-[2.2vh]">Thankyou for your patience</p>
            <p className="font-manropeB text-[5vh]">Successfully Completed <br /> Onboarding Process</p>
            <div className="flex items-center gap-4">
                <button
                    type="button"
                    className={`flex items-center gap-4 p-4 text-[2vh] text-center text-white bg-[#5E4DE0] rounded-xl shadow-2xl`}
                    style={{ color: "white" }}
                // onClick={handleSubmit}
                >
                    <Img src='images/Onboarding/OpenLink.svg' />
                    Go To My Website
                </button>
                <button
                    type="button"
                    className={`flex items-center gap-4 p-4 text-[2vh] text-center text-white bg-[#F1EFFF] rounded-xl shadow-2xl`}
                    style={{ color: "#202020" }}
                // onClick={handleSubmit}
                >
                    <Img src='images/Onboarding/Setting.svg' />
                    Open School Portal
                </button>
            </div>
        </div>
    );
}

export default ProcessComplete;